import { useEffect, useState } from "react";

import { appCRUD } from "../../../actions/app";
import { TableShared } from "../../../shared";
import { char } from "../../../utils";
import { Button, Dropdown, Space, Tag } from "antd";
import { MoreOutlined, EyeOutlined, FilePdfOutlined, FileExcelOutlined } from "@ant-design/icons";
import { useNotification } from "../../../utils/notificationProvider";

import { ExamTimetableView } from "./view";
import { ExamTimetableAdd } from "./add";

export const ExamTimetableContent = () => {
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [openView, setOpenView] = useState(false);
  const [data, setData] = useState([]);
  const [page, setPage] = useState(1);
  const [count, setCount] = useState(0);
  const [postsPerPage, setePostPerPage] = useState(10);
  const [nextPage, setNextPage] = useState(0);
  const [value, setValue] = useState("");
  const [dataId, setDataId] = useState(null);
  const [index, setIndex] = useState(0);
  const openNotification = useNotification();

  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      appCRUD
        .loadExamTimetable(postsPerPage, nextPage, value, "-id")
        .then((resp) => {
          setData(resp.data.results);
          setCount(resp.data.count);
        })
        .catch((error) => {
          openNotification(
            "error",
            "Error",
            <>
              Sorry...!
              <br />
              {error.message}
            </>
          );
        })
        .finally(() => {
          setLoading(false);
        });
    }, 500);
  }, [page, postsPerPage, value, index, nextPage]);

  const getStatusTag = (record) => {
    if (record.is_published) {
      return <Tag color="green">Published</Tag>;
    } else if (record.is_approved) {
      return <Tag color="blue">Approved</Tag>;
    } else if (record.is_generated) {
      return <Tag color="orange">Generated</Tag>;
    } else {
      return <Tag color="default">Draft</Tag>;
    }
  };

  const defaultColumns = [
    {
      key: "sn",
      title: "#",
      dataIndex: "sn",
      fixed: true,
      width: 50,
    },
    {
      key: "campas",
      title: "Campus",
      dataIndex: "campas",
      sortable: true,
      width: 200,
    },
    {
      key: "academic",
      title: "Academic Year",
      dataIndex: "academic",
      sortable: true,
      width: 150,
    },
    {
      key: "semister",
      title: "Semester",
      dataIndex: "semister",
      sortable: true,
      width: 150,
    },
    {
      key: "exam_period",
      title: "Exam Period",
      dataIndex: "exam_period",
      sortable: true,
      width: 180,
    },
    {
      key: "status",
      title: "Status",
      dataIndex: "status",
      sortable: true,
      width: 100,
    },
    {
      title: "Action",
      key: "operation",
      fixed: "right",
      width: 50,
      render: (record) => (
        <Dropdown
          menu={{
            items: [
              {
                label: "View",
                key: "view",
                icon: <EyeOutlined />,
              },
              {
                label: "Export PDF",
                key: "pdf",
                icon: <FilePdfOutlined />,
              },
              {
                label: "Export Excel",
                key: "excel",
                icon: <FileExcelOutlined />,
              },
            ],
            onClick: (event) => {
              switch (event.key) {
                case "view":
                  setDataId(record.id);
                  setOpenView(true);
                  break;
                case "pdf":
                  window.open(appCRUD.getExamExportPDFUrl(record.id), '_blank');
                  break;
                case "excel":
                  window.open(appCRUD.getExamExportExcelUrl(record.id), '_blank');
                  break;
                default:
              }
            },
          }}
          placement="bottomRight"
          arrow={{ pointAtCenter: true }}
        >
          <Space>
            <Button type="dashed" icon={<MoreOutlined />} size={"small"} />
          </Space>
        </Dropdown>
      ),
    },
  ];

  const formatDate = (dateStr) => {
    if (!dateStr) return "N/A";
    return new Date(dateStr).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' });
  };

  const dataItem = data?.map((dt, i) => ({
    id: dt.id,
    sn: i + 1,
    campas: dt.cumpas ? char.toTitleCase(dt.cumpas.name) : "N/A",
    academic: dt.academic ? char.toTitleCase(dt.academic.name) : "N/A",
    semister: dt.semister ? char.toTitleCase(dt.semister.name) : "N/A",
    exam_period: dt.exam_start_date && dt.exam_end_date
      ? `${formatDate(dt.exam_start_date)} - ${formatDate(dt.exam_end_date)}`
      : "Not Set",
    status: getStatusTag(dt),
    is_generated: dt.is_generated,
    is_approved: dt.is_approved,
    is_published: dt.is_published,
  }));

  const button = (
    <button
      className="btn btn-primary bg-gradient btn-border"
      onClick={() => setOpen(true)}
    >
      <span className="bi bi-plus-circle la-lg"></span> &nbsp; New Exam Timetable
    </button>
  );

  return (
    <>
      <ExamTimetableView open={openView} setOpen={setOpenView} dataId={dataId} />
      <ExamTimetableAdd
        open={open}
        setOpen={setOpen}
        index={index}
        setIndex={setIndex}
      />
      <div className="container-fluid">
        <div className="row mb-2">
          <div className="col-12">
            <p className="h6 fs-18 fw-bold text-dark">Examination Timetable</p>
          </div>
          <hr className="mt-3" />
        </div>
        <TableShared
          loading={loading}
          data={dataItem}
          setData={setData}
          page={page}
          setPage={setPage}
          count={count}
          postsPerPage={postsPerPage}
          setePostPerPage={setePostPerPage}
          setNextPage={setNextPage}
          value={value}
          setValue={setValue}
          defaultColumns={defaultColumns}
          button={button}
          link={"#"}
          showButton={true}
          setLoading={setLoading}
        />
      </div>
    </>
  );
};
